/* Marketing events the storefront publishes for the ad platforms.

   This file publishes Shopify customer events ONLY. No Meta code, no Google
   code, no direct call to either. A Custom Pixel in Settings > Customer
   events subscribes to these names and relays them, which keeps the ad
   platforms out of the theme and lets Shopify gate the relay on customer
   consent -- auto opt-in where that is legal, withheld in Quebec, the EU and
   the strict US states. An fbq() call written into the theme would sit
   outside that and fire everywhere, which is the thing to avoid.

   DELEGATED listeners on document, rather than edits inside irr-pdp.js,
   irr-cart.js and irr-heist.liquid. Those files are large and own their own
   behaviour; tracking is a separate concern, and one small file is easier to
   review or delete. Delegation also survives the cart drawer being
   re-rendered, which happens on every cart change.

   THE PRODUCT PAGE AND THE CART HAVE THE SAME TWO-STEP CONTROL. Both offer
   Buy once / Subscribe, and BOTH then offer every month / 2 months /
   3 months underneath:

     product page   .irr-pdp__plan   +  .irr-pdp__int   (in .irr-pdp)
     cart           .irr-cps__opt    +  .irr-cps__int   (in .irr-cps)

   This file originally handled only the cart's intervals, on the assumption
   that the product page had none. It does. That assumption cost two bugs:
   the interval was never recorded on a product-page intent, and clicking a
   product-page interval matched neither branch and published nothing at all.
   The two surfaces are handled symmetrically below for that reason.

   NO value / currency ON subscribe_intent, DELIBERATELY.

   The price attributes on these controls do not mean the same thing on the
   two surfaces, and the cart's do not mean what they look like:
     product page  data-price   the UNIT price            ($71.96)
     cart          data-cents   the WHOLE CART total      ($215.88)
   Every interval button on every cart line carries that same cart-wide
   figure, so a two-line cart reports the same number from both lines. Sent
   as `value` that is not a smaller or rounder number, it is a different
   measurement -- and Meta's value-based audiences and GA4 revenue would be
   averaging unit prices against cart totals.

   There is no per-line price in the cart markup to fix it with, so intent
   carries no value at all. It is an interest signal; counting it is the
   point. Real money is on `subscribe`, which the Custom Pixel derives from
   checkout_completed where Shopify gives exact line totals and a currency.
   If value-based optimisation on intent is ever wanted, the fix is a real
   per-line price attribute in the cart markup, not arithmetic here.

   PARAMETER NAMING -- EVERY PARAMETER IS PREFIXED WITH ITS EVENT.
   A GA4 custom dimension is keyed on the PARAMETER NAME across the whole
   property rather than per event, so any name two events share collapses
   their values into one bucket. subscribe_intent is also a different thing
   from subscribe: one is a shopper considering, the other is money taken.

   PUBLISHED
     subscribe_intent    a subscription purchase option was chosen, on the
                         product page or in the cart.
     cult_bundle_signup  the Black Friday teaser signup SUCCEEDED.

   No email or other personal data is published. Meta's Automatic Advanced
   Matching already reads the signup field itself. */

(function () {
  'use strict';

  function pub(name, payload) {
    try {
      var a = window.Shopify && window.Shopify.analytics;
      if (a && typeof a.publish === 'function') a.publish(name, payload || {});
    } catch (e) {}
  }

  function label(el) {
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : null;
  }

  /* ONE intent per surface per page view. Choosing Subscribe and then
     picking an interval is one interested shopper, but every interval is its
     own selling plan id -- so this is keyed on the surface alone. */
  var seen = {};
  function once(key) {
    if (seen[key]) return false;
    seen[key] = 1;
    return true;
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-plan]') : null;
    if (!t) return;

    var plan = t.getAttribute('data-plan');
    if (!plan) return; /* empty data-plan is the Buy once option */

    /* Which surface, by the element's own class -- not by looking for a
       container, so a markup reshuffle cannot silently drop one. */
    var cls = t.className || '';
    var isCart = cls.indexOf('irr-cps__') !== -1;
    var isPdp = cls.indexOf('irr-pdp__') !== -1;
    if (!isCart && !isPdp) return;

    var where = isCart ? 'cart' : 'pdp';
    if (!once(where)) return;

    var root = t.closest(isCart ? '.irr-cps' : '.irr-pdp') || document;
    var intSel = isCart ? '.irr-cps__int' : '.irr-pdp__int';

    /* Either they clicked an interval, or one is already selected beneath
       the Subscribe button -- "every month" is on by default, so a plain
       Subscribe click still has a real frequency to report. */
    var chosen = cls.indexOf('__int') !== -1
      ? t
      : (root.querySelector(intSel + '.is-on') || root.querySelector(intSel));

    var payload = {
      subscribe_intent_location: where,
      subscribe_intent_interval: label(chosen)
    };

    if (isCart) {
      /* data-line-key is "<variantId>:<hash>" */
      var key = (root.getAttribute && root.getAttribute('data-line-key')) || '';
      if (key) payload.subscribe_intent_variant_id = key.split(':')[0];
    } else {
      var sel = document.querySelector('[name="id"]');
      if (sel && sel.value) payload.subscribe_intent_variant_id = String(sel.value);
    }

    pub('subscribe_intent', payload);
  }, true);

  /* --- Black Friday teaser signup ---------------------------------------
     Fired on the page the shopper COMES BACK TO, not on submit.

     Publishing on submit tested fine in isolation but only ever reached Meta
     from /pages/the-heist, never from the home page: publish() hands the
     event to Shopify's pixel sandbox across an async boundary, and the form
     navigates away in the same beat, so it was a race the home page lost.

     Shopify returns customer_posted=true on success only. irr-heist.liquid
     prints .irr-ht__msg on that return, and its inline script -- which runs
     during parse, before this deferred file -- has already stripped the
     message from every section that was NOT the one submitted. So a single
     surviving .irr-ht__msg IS the signup that succeeded. */
  function signupLanded() {
    if (!/[?&]customer_posted=true/.test(window.location.search)) return;

    var msg = document.querySelector('.irr-ht__msg');
    if (!msg) return;

    var sec = msg.closest('.irr-ht');
    if (!sec) return;

    pub('cult_bundle_signup', {
      cult_bundle_signup_location: sec.classList.contains('irr-ht--page') ? 'teaser_page' : 'inline'
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', signupLanded, { once: true });
  } else {
    signupLanded();
  }
})();
